<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/erp/shipping"
        :showPrintBtn="true"
        :printBtnFunction="print"
    >
        <!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div class="pl-4" :alvqa="alvqa + '-title'" v-if="$i18n.locale=='ja'">
                {{ $route.params.alvId === 'new' ? $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') : 
                    data.recipientName + " " + $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') + " " + data.number }}
            </div>
            <div class="pl-4" :alvqa="alvqa + '-title'" v-else>
                {{ $route.params.alvId === 'new' ? $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') : 
                    data.number + " " + $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') + " " + data.recipientName }}
            </div>
        </template>

        <!-- EDIT FORM -->
        <template v-slot:editForm>
            <v-container fluid>
                <v-row>

                    <!-- Sender -->

                    <v-col cols="4">
                        <!-- Sender can be "any A-Z" for Incoming and Returning -->
                        <template v-if="(getShippingType == 'incoming') || (getShippingType == 'returning')">
                            <BaseEditPageAutocomplete 
                                :context="context"
                                field="Sender"
                                :label="shippingSenderLabel"
                                :withFreeText="false"
                                rules="required"
                                itemText="gemaName"
                                :additionalFunction="showShippingSenderAddress"
                                :alvqa="alvqa + '-erp-shipping-sender-textfield-autocomplete'"
                            >
                                <template v-slot:selection="{ item }">
                                    <div class="ellipsis" :alvqa="alvqa + '-autocomplete-shipping-sender-selection'">
                                        {{ item.gemaName }}
                                        <span v-if=" item.firstName !== undefined && item.lastName !== undefined && item.firstName !== '' && item.lastName !== ''">
                                            ({{ item.firstName }} {{ item.lastName }})
                                        </span>
                                    </div>
                                </template>

                                <template v-slot:items="{ items }">
                                    <v-list-item-content :alvqa="alvqa + '-autocomplete-shipping-sender-dropdown-' + items.alvId">
                                        <v-list-item-title :alvqa="alvqa + '-autocomplete-shipping-sender-dropdown-' + items.alvId + '-title'">
                                            {{ items.gemaName }}
                                                <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                                <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                        </v-list-item-title>
                                        <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-shipping-sender-dropdown-' + items.alvId + '-subtitle'">
                                            {{ items.alvId }}                                      
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>

                            </BaseEditPageAutocomplete>  
                        </template>    

                        <!-- Sender DROPDOWN for shipping and picking -->
                        <!-- shipping: Absender = Dropdown | type="warehouseOwn" -->
                        <!-- picking: Absender = Dropdown | type="warehouse" (NOT "warehouseOwn") -->
                        <template v-else>
                            <BaseEditPageDropdownAz
                                :context="context"
                                field="Sender"
                                :items="getSenderDropdownItems"
                                rules="required"
                                :clearable="false"
                                :label="shippingSenderLabel"
                                :additionalFunction="showShippingSenderAddress"
                                :alvqa="alvqa + '-dropdown-shipping-sender'"
                            /> 
                        </template>                 
                    </v-col>

                    <!-- Recipient -->
                    <v-col cols="4">
                        <template v-if="(getShippingType == 'shipping') || (getShippingType == 'picking')">
                            <BaseEditPageAutocomplete 
                                :context="context"
                                field="Recipient"
                                :label="shippingRecipient"
                                :withFreeText="false"
                                rules="required"
                                :additionalFunction="showShippingRecipientAddress"
                                :alvqa="alvqa + '-erp-shipping-recipient-textfield-autocomplete'"
                            >
                                <template v-slot:selection="{ item }">
                                    <div class="ellipsis" :alvqa="alvqa + '-autocomplete-shipping-recipient-selection'">
                                        {{ item.gemaName }}
                                        <span v-if="item.firstName !== undefined && item.lastName !== undefined && item.firstName !== '' && item.lastName !== '' && item.firstName !== null && item.lastName !== null">
                                            ({{ item.firstName }} {{ item.lastName }})
                                        </span>
                                    </div>
                                </template>

                                <template v-slot:items="{ items }">
                                    <v-list-item-content :alvqa="alvqa + '-autocomplete-shipping-recipient-dropdown-' + items.alvId">
                                        <v-list-item-title :alvqa="alvqa + '-autocomplete-shipping-recipient-dropdown-' + items.alvId + '-title'">
                                            {{ items.gemaName }}
                                                <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                                <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                        </v-list-item-title>
                                        <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-shipping-recipient-dropdown-' + items.alvId + '-subtitle'">
                                            {{ items.alvId }}                                      
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </BaseEditPageAutocomplete>
                        </template>

                        <!-- Recipient DROPDOWN for incoming and returning -->
                        <!-- incoming: Absender = Dropdown | type="warehouse" and type="warehouseOwn" -->
                        <!-- returning: Absender = Dropdown | type="warehouse" and type="warehouseOwn" -->
                        <template v-else>
                            <BaseEditPageDropdownAz
                                :context="context"
                                field="Recipient"
                                :items="getRecipientDropdownItems"
                                rules="required"
                                :clearable="false"
                                :label="shippingRecipient"
                                :additionalFunction="showShippingRecipientAddress"
                                :alvqa="alvqa + '-dropdown-shipping-recipient'"
                            /> 
                        </template>

                    </v-col>

                    <!-- Type -->
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Type"
                            :items="dropdownType"
                            rules="required"
                            :additionalFunction="fillDropdownFromAz"
                            :clearable="false"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_TYPE')"
                            :alvqa="alvqa + '-dropdown-shipping-type'"
                        /> 
                    </v-col>

                </v-row>

                <v-row>

                    <!-- Sender address -->
                    <v-col cols="4">
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="SenderFullAddress"
                            rows="5"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_SENDER_ADDRESS')" 
                            :alvqa="alvqa + '-textarea-sender-full-address'"
                        />
                    </v-col>

                    <!-- Recipient Invoice address -->
                    <v-col cols="4">
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="RecipientFullAddress"
                            rows="5"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ADDRESS_INVOICE')" 
                            :alvqa="alvqa + '-textarea-recipient-full-address'"
                        />
                    </v-col>
                    
                    <!-- Recipient Shipping address -->
                    <v-col cols="4">
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="RecipientFullShippingAddress"
                            rows="5"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ADDRESS_SHIPPING')" 
                            :alvqa="alvqa + '-textarea-recipient-full-shipping-address'"
                        />
                    </v-col>
                    
                </v-row>

                <!-- Other fields -->
                <v-row>

                    <!-- Date -->
                    <v-col cols="2">
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="Date"
                            :label="$t('lang_GENERIC_CAPTION_DATE')" 
                            :alvqa="alvqa + '-datepicker-shipping-date'"
                            rules="required"
                        />
                    </v-col>

                    <!-- Status -->
                    <v-col cols="2">
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Status"
                            :items="dropdownStatus" 
                            :clearable="false"
                            :label="$t('lang_GENERIC_CAPTION_STATUS')"
                            :alvqa="alvqa + '-dropdown-shipping-status'"
                        /> 
                    </v-col>

                    <!-- Language -->
                    <v-col cols="2">
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Language"
                            rules="required"
                            :items="dropdownLanguage" 
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :alvqa="alvqa + '-dropdown-shipping-language'"
                        /> 
                    </v-col>

                    <!-- Shipping document number -->
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="Number"
                            :readonly="true"
                            :clearable="false"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_NUMBER')"
                            :iconTooltipText="$t('lang_ERP_SHIPPING_TOOLTIP_NUMBER')"
                            :alvqa="alvqa + '-textfield-shipping-number'"
                        />
                    </v-col>

                    <!-- VAT ID -->
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="RecipientVatId"
                            :readonly="true"
                            :clearable="false"
                            :label="$t('lang_GENERIC_CAPTION_VAT_ID')"
                            :alvqa="alvqa + '-textfield-shipping-vat-id'"
                        />
                    </v-col>

                    <!-- Transaction ID -->
                    <v-col cols="2">
                        <BaseEditPageTextField
                            :context="context"
                            field="RecipientTransactionNumber"
                            :disabled="!!linkedInvoice || !!linkedShipping"
                            :clearable="!linkedInvoice  && !linkedShipping"
                            :label="$t('lang_ERP_CAPTION_TRANSACTION_NUMBER')"
                            :alvqa="alvqa + '-textfield-shipping-transaction-number'"
                        />
                    </v-col>

                </v-row>

                <!-- Notes for Shipping -->
                <v-row>
                    <v-col cols="12">
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="NoteForRecipient"
                            rows="3"
                            :label="$t('lang_GENERAL_CAPTION_NOTES')"
                            :alvqa="alvqa + '-textarea-notes'"
                        />
                    </v-col>

 
                </v-row>

                <!-- why does it need a <container> to put the row below the columns? -->
            </v-container>
        </template>

        <!-- PANEL  -->
        <template v-slot:panels>
            
            <!-- SHIPPING ROWS PANEL  -->
            <ShippingRowsEditPanel />  
            <ShippingRowsEditPanelDialog />

            <!-- DELETE ROW -->
            <DeletionDialog context="SelectedShippingShippingRows" />

            <!-- IMPORT ROWS -->
            <FileImportDialog :alvqaContext="alvqa" context="ShippingDetails" />
          
        </template>

    </BaseEditPage>
</template>

<script>
import BaseEditPage                 from '@/components/_base/BaseEditPage' 
import BaseIcon                     from '@/components/_buttons/BaseIcon'
import BaseButton                   from '@/components/_buttons/BaseButton'

import BaseEditPageTextField        from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown         from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDropdownAz       from '@/components/_editForm/BaseEditPageDropdownAz'
import BaseEditPageTextarea         from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker       from '@/components/_editForm/BaseEditPageDatePicker'
import BasePeriod                   from '@/components/_base/BasePeriod'
import BaseEditPageAutocomplete     from '@/components/_editForm/BaseEditPageAutocomplete'

import SearchDialog                 from '@/components/_dialogs/SearchDialog'
import DeletionDialog               from '@/components/_dialogs/DeletionDialog'
import FileImportDialog             from '@/components/_dialogs/FileImportDialog'

import ShippingRowsEditPanel        from './_panels/1_shippingrows/ShippingRowsEditPanel'
import ShippingRowsEditPanelDialog  from './_panels/1_shippingrows/ShippingRowsEditPanelDialog'

// No need for all of them, and on top they should be generic, also for Shipping documents
import {    DropdownErpInvoicesLanguages,
            DropdownErpShippingStatus,
            DropdownErpShippingType,
        } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ShippingEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseButton,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageDropdownAz,
        BaseEditPageTextarea,
        BaseEditPageDatePicker,
        BasePeriod,
        BaseEditPageAutocomplete,

        SearchDialog,
        DeletionDialog,
        ShippingRowsEditPanelDialog,

        ShippingRowsEditPanel,
        FileImportDialog
    },
    
    data() {
        return {
            context: "Shipping",
            alvqa: "erp-shipping-edit-form",
            menu: false,
        }
    },

    computed: {

        linkedInvoice() {
            return this.$store.getters['getShippingDetailsLinkedInvoice']
        },

        linkedShipping() {
          return this.$store.getters['getShippingDetailsLinkedShipping']
        },

        shippingSenderLabel() { 
            // caption depending on type of Shipping document, e.g.
            // Incoming = "Absender (alle A-Z | any A-Z)"
            // Shipping = "Absender (eigene Lager | own Warehouse)"
            // Picking = "Absender (nur Fremdlager | other Warehouses)"
            // Returning = "Absender (alle A-Z | any A-Z)"
            let typePostfix = ""
            switch (this.getShippingType) {
                case "incoming":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ANY_AZ')
                    break;
                case "shipping":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_OWN_WAREHOUSES')
                    break;
                case "picking":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_OTHER_WAREHOUSES')
                    break;
                case "returning":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ANY_AZ')
                    break;          
                default:
                    break;
            }
            return this.$t('lang_ERP_SHIPPING_CAPTION_SENDER_ABBREVIATION') + " (" + typePostfix + ")"
        },

        shippingRecipient() { 
            // caption depending on type of Shipping document, e.g.
            // Incoming = "Empfänger (alle Lager | all Warehouses)"
            // Shipping = "Empfänger (alle A-Z | any A-Z)"
            // Picking = "Empfänger (alle A-Z | any A-Z)"
            // Returning = "Empfänger (alle Lager | all Warehouses)"
            let typePostfix = ""
            switch (this.getShippingType) {
                case "incoming":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ALL_WAREHOUSES')
                    break;
                case "shipping":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ANY_AZ')
                    break;
                case "picking":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ANY_AZ')
                    break;
                case "returning":
                    typePostfix = this.$t('lang_SHIPPING_CAPTION_POSTFIX_ALL_WAREHOUSES')
                    break;          
                default:
                    break;
            }
            return this.$t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ABBREVIATION') + " (" + typePostfix + ")" 
        },

        dropdownLanguage() {
            return DropdownErpInvoicesLanguages
        },
        dropdownStatus() {
            return DropdownErpShippingStatus // fehlt noch in HELPERS !
        },
        dropdownType() {
            return DropdownErpShippingType
        },
        senderFullAddress() {
            return this.$store.getters.getShippingDetailsSenderFullAddress
        },
        recipientFullAddress() {
            return this.$store.getters.getShippingDetailsRecipientFullAddress
        },
        getShippingType() {
            return this.$store.getters.getShippingDetailsType
        },
        getSenderDropdownItems() {
            return this.$store.getters.getShippingSenderOptions
        },    
        getRecipientDropdownItems() {
            return this.$store.getters.getShippingRecipientOptions
        }, 
                 
    },
    methods: {
        
        fillDropdownFromAz() {
            this.$store.dispatch('fillDropdownFromAz', this.getShippingType)
            this.$store.commit('setShippingDetailsNoteForRecipient', null)
        },

        showShippingSenderAddress(item) {
            if(item !== null && item !== undefined) {
                // Sender address
                if (item.fullAddress != null)
                    // <br \> for v-card are replaced by \n for editable textarea
                    this.$store.commit('setShippingDetailsSenderFullAddress', item.fullAddress.replace(/<br\s*[\/]?>/gi, "\n"))
                else // empty address textarea    
                    this.$store.commit('setShippingDetailsSenderFullAddress', null)

            }  
        },

        showShippingRecipientAddress(item) {
            if(item !== null && item !== undefined) {
                
                // Recipient Invoice address
                if (item.fullAddress != null)
                    // <br \> for v-card are replaced by \n for editable textarea
                    this.$store.commit('setShippingDetailsRecipientFullAddress', item.fullAddress.replace(/<br\s*[\/]?>/gi, "\n"))
                else // empty address textarea    
                    this.$store.commit('setShippingDetailsRecipientFullAddress', null)

                // Recipient Shipping address
                if (item.fullShippingAddress != null)
                    // <br \> for v-card are replaced by \n for editable textarea
                    this.$store.commit('setShippingDetailsRecipientFullShippingAddress', item.fullShippingAddress.replace(/<br\s*[\/]?>/gi, "\n"))
                else  // empty address textarea
                    this.$store.commit('setShippingDetailsRecipientFullShippingAddress', null)

                // Set the language depeding on selected recipient
                if(item.language !== null) {
                    this.$store.commit('setShippingDetailsLanguage', item.language)
                } else {
                    this.$store.commit('setShippingDetailsLanguage', this.$store.getters.getUserLanguage)
                }
                if(item.finance.vatId !== null) {
                    this.$store.commit('setShippingDetailsRecipientVatId', item.finance.vatId)
                } else {
                    this.$store.commit('setShippingDetailsRecipientVatId', null)
                }

                // Set shipping note - only when recipient is Distributor or Group (typeOfAz  == 'D' or 'G')
                if(item.shippingNote !== null) {
                    this.$store.commit('setShippingDetailsNoteForRecipient', item.shippingNote)
                } else {
                    this.$store.commit('setShippingDetailsNoteForRecipient', null)
                }
            } 
            else {
                this.$store.commit('setShippingDetailsRecipientFullShippingAddress', null)
                this.$store.commit('setShippingDetailsRecipientFullAddress', null)
                this.$store.commit('setShippingDetailsLanguage', this.$store.getters.getUserLanguage)
                this.$store.commit('setShippingDetailsNoteForRecipient', null)
            }
        },
        print(){
            if(this.$route.params.alvId === 'new'){
                return
            }else{
                this.$store.commit("setSelectedShipping",[this.$store.getters.getShippingDetailsAlvId])
                this.$store.dispatch("printShipping")
                this.$store.commit("setSelectedShipping",[])
            }
        }
    },
}
</script>